import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  UpdateBidWorkflowMutation,
  UpdateBidWorkflowMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const UPDATE_BID_WORKFLOW_MUTATION = graphql(`
  mutation updateBidWorkflow(
    $updateWorkflow: UpdateWorkflowInput!
    $stageFilterRequest: WorkflowStageSearchRequest
  ) {
    updateBidWorkflow(updateWorkflow: $updateWorkflow) {
      id
      isDefault
      transitions {
        id
        group
        order
        stage {
          id
          name
          color
          iconColor
          iconName
          bidCount(WorkflowStageSearchRequest: $stageFilterRequest)
        }
      }
    }
  }
`);

export function useUpdateBidWorkflow(
  options: UseMutationOptions<
    UpdateBidWorkflowMutation,
    unknown,
    UpdateBidWorkflowMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  const { data, ...rest } = useGraphQlMutation(UPDATE_BID_WORKFLOW_MUTATION, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: ["bidWorkflow"] });
      await queryClient.invalidateQueries({ queryKey: ["bids"] });
      await queryClient.invalidateQueries({ queryKey: ["bid"] });

      options.onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      options?.onError?.(error, variables, context);
    },
  });
  return { data, ...rest };
}
